import instance from '../../../../api/axios'
import {
  CreateMemory,
  Memory,
  MemoryListRequest,
  PaginatedMemoriesResponse,
} from '../types/memory'

export const loadMemories = async (): Promise<Memory[]> => {
  const response = await instance.get('/memories')
  return response.data
}

export const loadMemoryList = async (
  request: MemoryListRequest,
): Promise<PaginatedMemoriesResponse> => {
  const params: Record<string, string> = {
    page: String(request.page),
    limit: String(request.limit || 25),
  }

  if (request.filters.name.trim()) {
    params.name = request.filters.name.trim()
  }

  if (request.filters.tag.trim()) {
    params.tag = request.filters.tag.trim()
  }

  const response = await instance.get('/memories/list', { params })
  return response.data
}

export const loadMemory = async (id: number): Promise<Memory> => {
  const response = await instance.get(`/memories/${id}`)
  return response.data
}

export const saveMemory = async (memory: CreateMemory): Promise<Memory> => {
  const response = await instance.post('/memories', memory)
  return response.data
}

export const modifyMemory = async (memory: Memory): Promise<Memory> => {
  const response = await instance.put('/memories', memory)
  return response.data
}

export const removeMemory = async (id: number): Promise<number> => {
  const response = await instance.delete(`/memories/${id}`)
  return response.data
}
